var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ComingSoon" } }, [
    _c(
      "div",
      { staticClass: "coming-soon-image" },
      [
        _c("ComingSoonDataIcon", {
          staticStyle: { width: "400px", height: "250px" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "coming-soon-text" }, [
      _c("h3", [
        _vm._v(_vm._s(_vm.noDataText || _vm.$t("chatbotv2.noContentAdded"))),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.scarpOrAddContent")))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "comming-soon-btn-container" },
      [
        _c("SupsisButton", { attrs: { ghost: "", disabled: _vm.disabled } }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.howItWorks")))]),
        ]),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            attrs: { primary: "", disabled: _vm.disabled },
            on: {
              click: function () {
                return _vm.addContent()
              },
            },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.actionText || _vm.$t("chatbotv2.addContent"))),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }